<div class="container-fluid row_banner pb-5">
  <app-header></app-header>
  <div class="border-none" #editorToolbar></div>
  <div class="container">
    <div
      class="row text-center justify-content-center"
      style="align-content: center"
    >
      <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
        <h1 class="w-100 fnt-w600-40" style="margin-top: 40px">
          Article Rewriter
        </h1>
        <span class="w-100 d-inline-block main_text mt-40"
          >Replace the wording and sentences of your articles with their best
          possible alternatives.
        </span>
      </div>
    </div>
    <div class="custom-card">
      <p
        class="text-left success-msg"
        *ngIf="got_recpatcha"
        [ngStyle]="{
          color: color,
          'background-color': '#f8d7da',
          padding: '2px'
        }"
      >
        <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
        {{ recaptcha_message }}
      </p>
      <div class="row">
        <div class="col-lg-1 col-md-2 col-12 icon-bar mt45">
          <app-upload-file-free-tools
            (uploadStarted)="onUploadStart()"
            (uploadFinished)="onUploadFinish()"
          ></app-upload-file-free-tools>
        </div>
        <div class="col-lg-11 col-md-10 col-12 top-bar">
          <div class="row">
           
            <div class="col-lg-6 col-md-12 col-sm-12" style="overflow: hidden"  >
              <div #editor spellcheck="false" class="upload-section tabcontent tab-active"  ></div>

              <div class="editSectionDiv" *ngIf="showParagraph">
                <div *ngFor="let content of contentArray">
                  <app-icons-free-tools [name]="'checktextIcon'" />
                  <h3 class="editor-heading">{{ content.header }}</h3>
                  <p class="paragraph">{{ content.paragraph }}</p>
                  <div class="upload-buttons">
                    <button
                      [ngClass]="{
                        paste: button.text === 'Sample Text',
                        click: button.text === 'Paste Text',
                        'default-class': true
                      }"
                      *ngFor="let button of content.buttons"
                      class="textButtons"
                      (click)="executeAction(button.action)"
                    >
                      <app-icons-free-tools [name]="button.icon" />{{
                        button.text
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <span *ngIf="editorState.characters !== 0">
                <app-icons-free-tools
                  [name]="'deleteIcon'"
                  (click)="clearEditor()"
                  class="icon-del"
                />
              </span>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12"  >
              <div
                class="result-section overflow-y-auto relative"
                style="overflow-x: hidden"
                contenteditable="false"
                spellcheck="false"
                data-gramm="false"
              >
                <p class="mb-0" id="editor2" (click)="onResultsClick($event)">
                  <img
                    src="../../assets/images/article-rewriter/result-section.png"
                    class="result-section-img"
                    style="
                      position: absolute;
                      top: 45%;
                      left: 49%;
                      text-align: center;
                      transform: translate(-50%, -50%);
                    "
                  />
                </p>

                <div
                  class="popup"
                  id="popupArt"
                  [style.top.px]="popup.y"
                  [style.left.px]="popup.x"
                  *ngIf="popup.content.length"
                >
                  <div>
                    <h6
                      style="
                        text-align: left;
                        font-size: 16px;
                        font-weight: 600;
                      "
                    >
                      Original word:
                    </h6>
                    <div>
                      <button
                        class="fs-6 popup-btn-primary"
                        [attr.data-replacement]="popup.content[0]"
                        (click)="handlePopupClick($event)"
                        style="
                          margin: 5px 0px;
                          background-color: #08ba9c;
                          border: 1px solid #08ba9c;
                          display: inline-block;
                          height: 30px;
                          padding: 1px 10px 30px 10px;
                          cursor: pointer;
                          border-radius: 5px;
                          color: #ffffff;
                        "
                      >
                        {{ popup.content[0] }}
                      </button>
                    </div>

                    <h6
                      style="
                        text-align: left;
                        font-size: 16px;
                        font-weight: 600;
                      "
                    >
                      Suggestion(s):
                    </h6>

                    <div class="flex flex-wrap gap-sm">
                      <button
                        *ngFor="let word of popup.content"
                        [attr.data-replacement]="word"
                        class="fs-6 btn-secondary py-0 px-3 rounded-lg"
                        (click)="handlePopupClick($event)"
                        style="
                          border: 1px solid #08ba9c;
                          border-radius: 5px;
                          margin-right: 5px;
                          background-color: #ffffff;
                          color: #08ba9c;
                          margin-bottom: 10px;
                          padding: 5px;
                          display: inline-block;
                          cursor: pointer;
                          text-align: left;
                        "
                      >
                        {{ word }}
                      </button>
                    </div>

                    <p style="font-size: 16px; font-weight: 600">Enter New:</p>
                    <div style="margin-top: 10px; display: flex">
                      <input
                        #myInput
                        type="text"
                        class="fs-6 popup-input flex-1 rounded-lg px-2"
                        [placeholder]="'e.g. ' + popup.content[0]"
                        id="popup-replacement-input"
                        class="form-control"
                        type="text"
                        id="userInput"
                        [ngClass]="{ border: myInput.value.trim().length > 0 }"
                        style="
                          height: 40px;
                          border-radius: 5px;
                          outline: none;
                          box-shadow: none;
                          margin-right: 5px;
                        "
                      />

                      <button
                        class="popuoUseBtn"
                        (click)="handlePopupClick($event)"
                        [disabled]="!myInput.value.trim()"
                      >
                        Use
                      </button>
                    </div>
                  </div>
                  <div (click)="dismissPopup()">
                    <img
                      alt="popup_img"
                      src="../../assets/images/editorimages/articlecross.svg"
                      style="margin-top: -23px; height: 25px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="progress-loader-div">
            <div class="progress-loader" *ngIf="loaderAlert"></div>
          </div>
          <div class="edit-buttons">
            <div class="word-count">
              <p
                class="word-limit"
                style="font-size: 15px; font-weight: 500; text-align: left"
              >
                Words:{{ f(editorState.words) }}
              </p>
              <p style="font-size: 15px; font-weight: 500; text-align: left">
                Total Characters: {{ f(editorState.characters) }}
              </p>
            </div>

            <div class="right-buttons">
              <div style="display: flex">
                <button
                  id="adv-tech"
                  class="download-img tooltipss butn"
                  aria-label="Try Again"
                  (click)="handleButtonClick()"
                  *ngIf="gotresponse"
                >
                  <img id="retry" />
                  <span class="tooltiptext">Retry</span>
                </button>
                <button
                  id="adv-tech"
                  class="download-img tooltipss butn"
                  (click)="copyText()"
                  *ngIf="gotresponse"
                >
                  <img
                    src="../../assets/images/About us-assets/copy-frame.svg"
                    alt=""
                  />
                  <span class="tooltiptext">Copy</span>
                  <span
                    class="tooltiptext"
                    id="copried_txt"
                    *ngIf="!showParagraph && copiedtext"
                    >Copied</span
                  >
                </button>

                <button
                  class="unquieBtn"
                  (click)="downloadText()"
                  *ngIf="gotresponse"
                >
                  <img
                    src="../assets/images/plagiarism checker1/downPlag.svg"
                    alt="download-img"
                    class="unquieBtnImg"
                  />
                  <span> Download</span>
                </button>
              </div>
              <div *ngIf="captchaVisible" class="captcha-modal-overlay">
                <div class="captcha-modal">
                  <div
                    id="recaptcha-container"
                    class="recaptcha-container"
                    data-size="compact"
                    data-theme="light"
                  ></div>
                </div>
              </div>
              <div>
                <button
                  class="btn btn-dark btn-summarize"
                  (click)="handleButtonClick()"
                >
                  Rewrite Article
                </button>

                <!-- <button
                class="btn btn-dark btn-summarize"
                (click)="editorState.words < 15 ? invokeModal($event) : handleButtonClick()"
                [attr.data-target]="'empty-content-modal'"
              >
                Rewrite Article
              </button> -->
              </div>
            </div>
          </div>

          <div
            *ngIf="error"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="error"
            class="content-div"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center tab_screen" style="margin-top: 9%">
              <app-icons-free-tools name="errorIcon" />

              <div style="margin-left: 16px">
                <p
                  class="error mt-4 content-div-p"
                  style="
                    font-size: 22px;
                    font-weight: 500;
                    line-height: 33.89px;
                  "
                >
                  {{ errorAlerts }}
                </p>
              </div>

              <button class="butn-alert" (click)="closeErrorDiv()">Ok</button>
            </div>
          </div>

          <div
            *ngIf="success"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="success"
            class="content-div content-div-p"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center tab_screen" style="margin-top: 9%">
              <app-icons-free-tools name="successIcon" />

              <p
                *ngIf="success"
                class="error mt-4"
                style="font-size: 24px; font-weight: 500; line-height: 33.89px"
              >
                {{ successAlert }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- new mobile design  -->
    <!-- <div style="display: flex; flex-direction: column; gap: 0.9rem">
      <div class="mobile-view-custom-card">
        <div class="mobile-view-container">
          <div id="icetab-container">
            <div class="icetab current-tab">Input</div>
            <div class="icetab">Output</div>
          </div>
       

          <div id="icetab-content">
            <div #editor spellcheck="false" class="tabcontent tab-active "  ></div>
            
            <div
              class="overflow-y-auto relative tabcontent "
              style="overflow-x: hidden"
              contenteditable="false"
              spellcheck="false"
              data-gramm="false"
            >
              <p class="mb-0" id="editor2" (click)="onResultsClick($event)">
                <img
                  src="../../assets/images/article-rewriter/result-section.png"
                  class="result-section-img"
                  style="
                    position: absolute;
                    top: 45%;
                    left: 49%;
                    text-align: center;
                    transform: translate(-50%, -50%);
                  "
                />
              </p>

              <div
                class="popup"
                id="popupArt"
                [style.top.px]="popup.y"
                [style.left.px]="popup.x"
                *ngIf="popup.content.length"
              >
                <div>
                  <h6
                    style="text-align: left; font-size: 16px; font-weight: 600"
                  >
                    Original word:
                  </h6>
                  <div>
                    <button
                      class="fs-6 popup-btn-primary"
                      [attr.data-replacement]="popup.content[0]"
                      (click)="handlePopupClick($event)"
                      style="
                        margin: 5px 0px;
                        background-color: #08ba9c;
                        border: 1px solid #08ba9c;
                        display: inline-block;
                        height: 30px;
                        padding: 1px 10px 30px 10px;
                        cursor: pointer;
                        border-radius: 5px;
                        color: #ffffff;
                      "
                    >
                      {{ popup.content[0] }}
                    </button>
                  </div>

                  <h6
                    style="text-align: left; font-size: 16px; font-weight: 600"
                  >
                    Suggestion(s):
                  </h6>

                  <div class="flex flex-wrap gap-sm">
                    <button
                      *ngFor="let word of popup.content"
                      [attr.data-replacement]="word"
                      class="fs-6 btn-secondary py-0 px-3 rounded-lg"
                      (click)="handlePopupClick($event)"
                      style="
                        border: 1px solid #08ba9c;
                        border-radius: 5px;
                        margin-right: 5px;
                        background-color: #ffffff;
                        color: #08ba9c;
                        margin-bottom: 10px;
                        padding: 5px;
                        display: inline-block;
                        cursor: pointer;
                        text-align: left;
                      "
                    >
                      {{ word }}
                    </button>
                  </div>

                  <p style="font-size: 16px; font-weight: 600">Enter New:</p>
                  <div style="margin-top: 10px; display: flex">
                    <input
                      #myInput
                      type="text"
                      class="fs-6 popup-input flex-1 rounded-lg px-2"
                      [placeholder]="'e.g. ' + popup.content[0]"
                      id="popup-replacement-input"
                      class="form-control"
                      type="text"
                      id="userInput"
                      [ngClass]="{ border: myInput.value.trim().length > 0 }"
                      style="
                        height: 40px;
                        border-radius: 5px;
                        outline: none;
                        box-shadow: none;
                        margin-right: 5px;
                      "
                    />

                    <button
                      class="popuoUseBtn"
                      (click)="handlePopupClick($event)"
                      [disabled]="!myInput.value.trim()"
                    >
                      Use
                    </button>
                  </div>
                </div>
                <div (click)="dismissPopup()">
                  <img
                    alt="popup_img"
                    src="../../assets/images/editorimages/articlecross.svg"
                    style="margin-top: -23px; height: 25px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mobile-icon-bar">
            <app-upload-file-free-tools
              (uploadStarted)="onUploadStart()"
              (uploadFinished)="onUploadFinish()"
            ></app-upload-file-free-tools>

            <div style="display: flex">
              <button
                id="adv-tech"
                class="download-img tooltipss butn"
                aria-label="Try Again"
                (click)="handleButtonClick()"
              >
                <img id="retry" />
                <span class="tooltiptext">Retry</span>
              </button>
              <button
                id="adv-tech"
                class="download-img tooltipss butn"
                (click)="copyText()"
              >
                <img
                  src="../../assets/images/About us-assets/copy-frame.svg"
                  alt=""
                />
                <span class="tooltiptext">Copy</span>
                <span
                  class="tooltiptext"
                  id="copried_txt"
                  *ngIf="!showParagraph && copiedtext"
                  >Copied</span
                >
              </button>

              <button class="unquieBtn" (click)="downloadText()">
                <img
                  src="../assets/images/plagiarism checker1/downPlag.svg"
                  alt="download-img"
                  class="unquieBtnImg"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-bottom-bar">
        <div class="word-count">
          <p
            class="word-limit"
            style="font-size: 15px; font-weight: 500; text-align: left"
          >
            Words:{{ f(editorState.words) }}
          </p>
          <p style="font-size: 15px; font-weight: 500; text-align: left">
            Total Characters: {{ f(editorState.characters) }}
          </p>
        </div>
        <div *ngIf="captchaVisible" class="captcha-modal-overlay">
          <div class="captcha-modal">
            <div
              id="recaptcha-container"
              class="recaptcha-container"
              data-size="compact"
              data-theme="light"
            ></div>
          </div>
        </div>
        <div>
          <button
            class="btn btn-dark btn-summarize"
            (click)="handleButtonClick()"
          >
            Rewrite Article
          </button>
        </div>
      </div>
    </div> -->
    <!-- new mobile design  -->
  </div>
  </div>

  <!-- <app-artical></app-artical> -->

 
  <app-modal parent="content-exceeds-words-limit-modal">
    <modal-content>
      <section class="text-center grid justify-center">
        <h3>Content Exceeds Words Limit</h3>

        <p>
          Please reduce your content to less than
          {{ f(authLimits[authState].words) }} words.
        </p>

        <div>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>

  <app-modal parent="empty-content-modal">
    <modal-content>
      <section class="text-center grid justify-center">
        <h3>Enter at least 15 words.</h3>

        <p>Please enter at least 15 words to proceed.</p>

        <div>
          <button
            class="check-grammar-btn w-unset"
            (click)="dismissModal($event)"
            style="max-width: unset !important"
          >
            Dismiss
          </button>
        </div>
      </section>
    </modal-content>
  </app-modal>

